<template>
  <div class="_content md-elevation-1">

    <div class="md-autocomplete-loading" v-if="isPromisePending">
      <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
    </div>

    <collapse :collapse="['FILTERS']" icon="keyboard_arrow_down" :defaultActive="1">
      <template slot="md-collapse-pane-1">
        <div class="md-layout">

          <div class="md-layout-item md-small-size-100">
            <md-field class="_uiKitInput">
              <label>Due When</label>
              <md-select v-model="form.dueWhen">
                <md-option
                  v-for="(_option, _index) in dueWhenOptions"
                  :key="_index"
                  :value="_option.id"
                  >{{ _option.label }}</md-option
                >
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-small-size-100">
            <md-datepicker 
              md-immediately 
              v-model="form.dueDateFrom" 
              class="_uiKitInput" 
              v-if="selectedDueWhen && selectedDueWhen.isDueDateFromNeeded"
            >
              <label>From</label>
            </md-datepicker>
          </div>

          <div class="md-layout-item md-small-size-100">
            <md-datepicker 
              md-immediately 
              v-model="form.dueDateTo" 
              class="_uiKitInput" 
              v-if="selectedDueWhen && selectedDueWhen.isDueDateToNeeded"
            >
              <label>To</label>
            </md-datepicker>
          </div>

          <div class="md-layout-item md-size-100">
            <ReportSearchModal v-if="!userId" v-model="form.assignees" :config="formConfig.assigneeConfig" />
          </div>

          <div class="md-layout-item md-size-50 md-small-size-100">
            <md-button 
              class="md-primary space" 
              @click="atSearch"
            ><md-icon>search</md-icon>Search </md-button>
            <md-button 
              class="space" 
              @click="onFormReset"
            ><md-icon>search</md-icon>Clear Filters </md-button>
            <md-button 

              @click="downloadCSV"
            ><md-icon>assignment_returned</md-icon>Download </md-button>
          </div>

        </div>
      </template>
    </collapse>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import Amplify, { Auth, API, graphqlOperation, JS } from "aws-amplify";
import * as queries from "@/graphql/queries";
import * as queries_custom from "@/graphql/queries_custom";

import { Collapse } from "@/components";

import ReportSearchModal from "@/pages/Reports/include/ReportSearchModal";
// import ReportConfigDefaults from "./configs/ReportConfigDefaults";
import DownloadCSV from "@/pages/Reports/include/DownloadCSV";

import TasksFilterConfig from './TasksFilterConfig';

export default {
  components: {
    Collapse,
    ReportSearchModal,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    atSearch: {
      type: Function,
      required: false,
    },
    csvItems: {
      type: Array,
      required: false,
    },
    csvColumns: {
      type: Object,
      required: false,
    },
    csvReportName: {
      type: String,
      default: 'tasks-report',
    },
    userId: {
      type: String,
      required: false,
    }
  },
  data: () => ({
    form: {
      assignees: [],
      dueWhen: null,
      dueDateFrom: null,
      dueDateTo: null,
    },
    dueWhenOptions: TasksFilterConfig.dueWhenOptions,
    isPromisePending: false,
    formConfig: TasksFilterConfig,
  }),
  computed: {
    selectedDueWhen() {
      return this.dueWhenOptions.find(_option => _option.id == this.form.dueWhen);
    }
  },
  watch: {
    /**
     * Whenever any value changes in form model - emit the new model value
     */
    'form': {
      deep: true,
      immediate: true,
      handler: function() {
        this.$emit('input', this.form);
      }
    }
  },
  methods: {
    /**
     * Reset filter form model
     * @return {void}
     */
    onFormReset() {
      this.$set(this, 'form', {
        assignees: [],
        dueWhen: null,
        dueDateFrom: null,
        dueDateTo: null,
      });
    },
    /**
     * Download CSV of provided items
     * @return {void}
     */
    async downloadCSV() {
      if (!this.csvItems || !this.csvItems.length) {
        return DownloadCSV.download(this.csvReportName, [], this.csvColumns);
      }
      return DownloadCSV.download(this.csvReportName, this.csvItems, this.csvColumns);
    }
  },
};
</script>

<style lang="scss">
</style>
